import { useEffect, useState } from "react";
import { ConversationDdClustersToConsider, SortType } from "fe-common/graphql";
import { usePatient } from "../state/patientContext";
import { useDaoContext } from "fe-web-components/diseaseview/DaoContext";
import { PatientCrs } from "../types/patientConversationAliasing";
import { useConversationDriver } from "../driver/ConversationDriverProvider";

export interface ClusterWithCr extends ConversationDdClustersToConsider {
  cr: PatientCrs;
  prob: number;
  isPrimaryDisease: boolean; //same as background disorder
}

export const useConversationDD = (): { loading: boolean } => {
  const [loading, setLoading] = useState<boolean>(false);

  const { setConversationDDResult } = usePatient();

  const dao = useDaoContext();
  const driver = useConversationDriver();
  const context = driver.getCurrentContext();

  useEffect(() => {
    if (!context) return;
    setLoading(true);
    (async () => {
      const {
        ddClusters: dd,
        primaryDDClusters,
        urgent,
        navigationRecommendation,
      } = await dao.runDDForConversation(context);
      const clustersWithCrs: ClusterWithCr[] = dd.clustersToConsider
        .filter((cluster) => cluster.sortType === SortType.PatientProb)
        .map((cluster) => {
          const cr = dd.clinicalReasoning.find(
            (cr) => cr.id === cluster.crIds[0],
          );
          return {
            ...cluster,
            cr,
            prob: cluster.scores.adjustedNormalized,
            isPrimaryDisease: primaryDDClusters.includes(cluster.id),
          };
        });

      const crs: PatientCrs[] = dd.clinicalReasoning;
      setLoading(false);
      setConversationDDResult({
        ddClusters: clustersWithCrs,
        crs: crs,
        urgency: urgent.urgencyLevelId,
        navigationRecommendation: navigationRecommendation,
        options: dd.options,
      });
    })();
  }, [dao, context, setConversationDDResult]);

  return { loading };
};
